import { Col, Row, TextInput } from 'ui';

export type JoinedProgramsListFiltersFormValues = {
  search?: string;
};

const JoinedProgramsListFilters = () => (
  <Row gutter="ms">
    <Col flex="1">
      <TextInput
        hasSearch
        item={{
          label: 'Search',
          name: 'search',
        }}
      />
    </Col>
  </Row>
);

export default JoinedProgramsListFilters;
